import type React from "react"
import { FaCheckCircle } from "react-icons/fa"
import "../../css/select-all-toggle.css"

interface SelectAllToggleProps {
  isAllSelected: boolean
  onToggle: () => void
}

const SelectAllToggle: React.FC<SelectAllToggleProps> = ({ isAllSelected, onToggle }) => {
  return (
    <div className={`toggle-icon ${isAllSelected ? "on" : ""}`} onClick={onToggle}>
      <div className="handle">
        <FaCheckCircle />
      </div>
    </div>
  )
}

export default SelectAllToggle